export enum CrediflowSupportedCountry {
    SE = 'SE',
    NO = 'NO',
    DK = 'DK',
    FI = 'FI',
}

export type CrediflowPartyService = {
    serviceTypeId: string;
    compliance: string;
    instructions: string | null;
};

export type CrediflowParty = {
    id: string | null;
    name: string;
    contactName: string | null;
    countryCode: string;
    cin: string;
    email: string | null;
    address1: string | null;
    address2: string | null;
    zipCode: string | null;
    city: string | null;
    phone: string | null;
    fax: string | null;
    gln: string | null;
    vat: string | null;
    bankgiro: string | null;
    plusGiro: string | null;
    iban: string | null;
    bic: string | null;
    services: CrediflowPartyService[];
};

export type CrediflowPartyLookupResult = {
    parties: CrediflowParty[];
    totalResources: number;
};
